__turbopack_context__.v({
  "active": "Vs2N5a_active",
  "amountDue": "Vs2N5a_amountDue",
  "backgroundTransition": "Vs2N5a_backgroundTransition",
  "container": "Vs2N5a_container",
  "desktopHeaderForCustomer": "Vs2N5a_desktopHeaderForCustomer",
  "desktopHeaderForNoWidgets": "Vs2N5a_desktopHeaderForNoWidgets",
  "desktopHeaderForVendor": "Vs2N5a_desktopHeaderForVendor",
  "dotMenu": "Vs2N5a_dotMenu",
  "dueDate": "Vs2N5a_dueDate",
  "header": "Vs2N5a_header",
  "installmentList": "Vs2N5a_installmentList",
  "label": "Vs2N5a_label",
  "listItemForCustomer": "Vs2N5a_listItemForCustomer",
  "listItemForUserWithoutWidgets": "Vs2N5a_listItemForUserWithoutWidgets",
  "listItemForVendor": "Vs2N5a_listItemForVendor",
  "mobileHeader": "Vs2N5a_mobileHeader",
  "name": "Vs2N5a_name",
  "paymentDate": "Vs2N5a_paymentDate",
  "pretext": "Vs2N5a_pretext",
  "pulse-lightGray": "Vs2N5a_pulse-lightGray",
  "selector": "Vs2N5a_selector",
  "shake": "Vs2N5a_shake",
  "shakeX": "Vs2N5a_shakeX",
  "status": "Vs2N5a_status",
  "value": "Vs2N5a_value",
  "warning": "Vs2N5a_warning",
});
